module.exports = __webpack_public_path__ + "static/media/badge1.52d9ee7d.svg";